const INITIAL_VALUES = {
  supplierName: '',
  supplierRfc: '',
  departments: [],
  hasRfc: true,
};

export default INITIAL_VALUES;
